import React from "react";
import { Navigate } from "react-router-dom";

const RedirectToValidateProduct = () => {

  return <Navigate to="/product/validate" />;
};

export default RedirectToValidateProduct